import React from "react";

import SettingsSidebar from "./SettingsSidebar";
import Header from "../common/Header";

const Company = () => {
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl h-[calc(100vh-32px)] overflow-x-hidden w-full mr-4 relative">
        <div className="px-2 xs:px-5 relative overflow-hidden">
          <div className=" overflow-hidden">
            <Header text="Settings" />
          </div>
          <div className="pt-2 lg:pt-4">
            <div className="flex">
              <div className=" flex w-[20%] xm:w-[10%] md:w-[25%] xl:w-[20%] 2xl:w-[15%]">
                <SettingsSidebar />

                <span className="w-[1px] bg-[#F2F2F2] block mx-3 mt-2"></span>
              </div>
              <div className=" overflow-y-auto h-[calc(100vh-155px)] md:h-[calc(100vh-140px)] w-full overflow_x_scroll_style">
                <div className=" flex flex-col items-center justify-center h-full bg-white">
                  <h2 className="text-black font-bold text-[30px] md:text-[40px] text-center">
                    Coming Soon
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Company;
